import { useEffect, useState } from 'react';

import { IActiveViewRange } from 'src/pages/gantt/gantt.interfaces';
import { useGetAssignedTimeStripesForActiveGantt } from 'src/hooks/time-stripes/get-time-stripes.hook';
import { useGetGanttRecordsByRangeForActiveGantt } from 'src/hooks/gantts-records/get-gantt-records-by-range.hook';

import { buildGanttData } from './gantt-calendar.helpers';

export const useGetGanttData = (
  viewRange: IActiveViewRange,
  employees: any[],
  absenceReasons: any[],
  employeesWorkingHours: any[]
) => {
  const [ganttData, setGanttData] = useState([]);

  const { timeStripes, loading: timeStripesLoading } =
    useGetAssignedTimeStripesForActiveGantt(viewRange);
  const { ganttRecords, loading: ganttRecordsLoading } =
    useGetGanttRecordsByRangeForActiveGantt(viewRange);

  useEffect(() => {
    setGanttData(
      buildGanttData(employees, ganttRecords, timeStripes, absenceReasons, employeesWorkingHours)
    );
  }, [employees, timeStripes, ganttRecords, absenceReasons, employeesWorkingHours]);

  return {
    ganttData,
    loading: timeStripesLoading || ganttRecordsLoading,
  };
};
